var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import serializeParams from 'qs/lib/stringify';
import AbstractConnection from './AbstractConnection';

var WebSocketConnection = function (_AbstractConnection) {
  _inherits(WebSocketConnection, _AbstractConnection);

  function WebSocketConnection(url, dispatcher) {
    _classCallCheck(this, WebSocketConnection);

    var _this = _possibleConstructorReturn(this, (WebSocketConnection.__proto__ || Object.getPrototypeOf(WebSocketConnection)).call(this, url, dispatcher));

    _this.connectionType = 'websocket';
    _this.url = url + '/components';
    _this.dispatcher = dispatcher;

    if (_this.url.match(/^wss?:\/\//)) {
      if (console && console.log) {
        console.log('WARNING: Using connection urls with protocol specified is deprecated');
      }
      // TODO fix for node
    } else if (window.location.protocol === 'https:') {
      _this.url = 'wss://' + _this.url;
    } else {
      _this.url = 'ws://' + _this.url;
    }

    // IE cannot handle urls like ws:////
    // Fix them here so it does not break horribly.
    while (_this.url.indexOf('////') > -1) {
      _this.url = _this.url.replace('////', '//');
    }

    var query = serializeParams(_this.dispatcher.query);
    _this.conn = new _this.dispatcher.WebSocket(query ? _this.url + '?' + query : _this.url);

    _this.conn.onopen = function (event) {
      return _this.dispatcher.connectionEstablished();
    };

    _this.conn.onmessage = function (event) {
      var eventData = event.data;
      try {
        eventData = JSON.parse(eventData);
      } catch (err) {}

      return _this.onMessage(eventData);
    };

    _this.conn.onclose = function (event) {
      return _this.onClose(event);
    };

    _this.conn.onerror = function (event) {
      return _this.onError(event);
    };
    return _this;
  }

  _createClass(WebSocketConnection, [{
    key: 'close',
    value: function close() {
      return this.conn.close();
    }
  }, {
    key: 'sendEvent',
    value: function sendEvent(event) {
      _get(WebSocketConnection.prototype.__proto__ || Object.getPrototypeOf(WebSocketConnection.prototype), 'sendEvent', this).apply(this, arguments);
      return this.conn.send(event.serialize());
    }
  }]);

  return WebSocketConnection;
}(AbstractConnection);

export default WebSocketConnection;